import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { CardModule } from "@liberty-financial/ng-components";

import {
  SummaryCardComponent,
  SummaryCardIconDirective,
  SummaryCardHeaderDirective,
  SummaryCardBodyDirective,
  SummaryCardFlagDirective,
  SummaryCardFlagsDirective,
  SummaryCardActionDirective,
  SummaryCardActionsDirective, } from "./summary-card.component";

@NgModule({
  imports: [CommonModule, CardModule, RouterModule],
  declarations: [SummaryCardComponent, SummaryCardIconDirective, SummaryCardHeaderDirective, SummaryCardBodyDirective, SummaryCardFlagDirective, SummaryCardFlagsDirective, SummaryCardActionDirective, SummaryCardActionsDirective],
  exports: [SummaryCardComponent, SummaryCardIconDirective, SummaryCardHeaderDirective, SummaryCardBodyDirective, SummaryCardFlagDirective, SummaryCardFlagsDirective, SummaryCardActionDirective, SummaryCardActionsDirective]
})
export class SummaryCardModule{}
